/**
 * Maps each UV inserts visualiser route name to its corresponding config handle
 * (matching `uv-inserts-config.liquid`) and product key (matching
 * `window.giftWrapData.insertsAndCards.products` for the cart service).
 */
export type UvInsertRouteMeta = {
  /** Handle matching the `id` in `uv-inserts-config.liquid` configs array. */
  configHandle: string;
  /** Product key used in `UserInputContext.visualiserSelection.productKey` (for Footer/Info display) and in the legacy visualiserCartService fallback path. */
  productKey: string;
};

export const VISUALISER_ROUTE_META: Record<string, UvInsertRouteMeta> = {
  boxInsertBlankMessage: {
    configHandle: 'insert-custom-text-only',
    productKey: 'inserts',
  },
  boxInsertBlankPhotoUpload: {
    configHandle: 'insert-photo-upload',
    productKey: 'inserts',
  },
  boxInsertThemedMessage: {
    configHandle: 'insert-themed-message',
    productKey: 'themedInserts',
  },
  boxInsertThemedPhotoUpload: {
    configHandle: 'insert-themed-photo-upload',
    productKey: 'themedInserts',
  },
  cardBlankCustomMessage: {
    configHandle: 'card-custom-message',
    productKey: 'customGreetingsCards',
  },
  cardBlankPhotoUpload: {
    configHandle: 'card-photo-upload',
    productKey: 'customGreetingsCards',
  },
  cardThemedCustomMessage: {
    configHandle: 'card-themed-custom-message',
    productKey: 'themedGreetingsCards',
  },
  cardThemedPhotoUpload: {
    configHandle: 'card-themed-photo-upload',
    productKey: 'themedGreetingsCards',
  },
  cardBlankPredesigned: {
    configHandle: 'card-predesigned-message',
    productKey: 'greetingsCards',
  },
  boxInsertBridalTextImage: {
    configHandle: 'bridal-insert-text-image',
    productKey: 'bridalInsert',
  },
  boxInsertBridalTextOnly: {
    configHandle: 'bridal-insert-text-only',
    productKey: 'bridalInsert',
  },
  cardBridalTextImage: {
    configHandle: 'bridal-card-text-image',
    productKey: 'bridalGreetingsCard',
  },
  cardBridalTextOnly: {
    configHandle: 'bridal-card-text-only',
    productKey: 'bridalGreetingsCard',
  },
  boxInsertMensBlankMessage: {
    configHandle: 'mens-insert-custom-text-only',
    productKey: 'mensInserts',
  },
  boxInsertMensBlankPhotoUpload: {
    configHandle: 'mens-insert-photo-upload',
    productKey: 'mensInserts',
  },
  cardMensBlankCustomMessage: {
    configHandle: 'mens-card-custom-message',
    productKey: 'mensGreetingsCards',
  },
  cardMensBlankPhotoUpload: {
    configHandle: 'mens-card-photo-upload',
    productKey: 'mensGreetingsCards',
  },
  boxInsertMensWhiteMessage: {
    configHandle: 'mens-white-insert-custom-text-only',
    productKey: 'mensInserts',
  },
  boxInsertMensWhitePhotoUpload: {
    configHandle: 'mens-white-insert-photo-upload',
    productKey: 'mensInserts',
  },
  boxInsertMensThemedMessage: {
    configHandle: 'mens-insert-themed-message',
    productKey: 'mensThemedInserts',
  },
  boxInsertMensThemedPhotoUpload: {
    configHandle: 'mens-insert-themed-photo-upload',
    productKey: 'mensThemedInserts',
  },
  cardMensWhiteCustomMessage: {
    configHandle: 'mens-white-card-custom-message',
    productKey: 'mensGreetingsCards',
  },
  cardMensWhitePhotoUpload: {
    configHandle: 'mens-white-card-photo-upload',
    productKey: 'mensGreetingsCards',
  },
};

/**
 * Returns true when a route name corresponds to a visualiser page.
 * @param {string} routeName - The route name to check.
 * @returns {boolean} True if the route is a visualiser page.
 */
export function isVisualiserRoute(routeName: string): boolean {
  return Object.prototype.hasOwnProperty.call(VISUALISER_ROUTE_META, routeName);
}
